/* MittelBoost Marke (Brand Guidelines v1.0, Juni 2026).
   M mit 3 Speed-Lines; Verlauf vertikal von unten nach oben:
   auf Dunkel Markengrün→Boost-Lime, auf Hell Forest→Markengrün.
   App-Icon-Variante (withLines=false) laut Brandbook ohne Speed-Lines. */
import React from 'react';

const GRADIENTS = {
  dark:  ['#1DBE74', '#B4EF4A'],
  light: ['#0E3D2E', '#1DBE74'],
};

const MONO = {
  'mono-white': '#FFFFFF',
  'mono-dark':  '#0E3D2E',
};

export function MittelBoostMark({ size = 28, variant = 'dark', withLines = true, style }) {
  const gradId = React.useId();
  const mono = MONO[variant] || null;
  const grad = GRADIENTS[variant] || GRADIENTS.dark;
  const fill = mono || `url(#${gradId})`;
  const minX = withLines ? 0 : 20;
  const width = withLines ? 76 : 56;
  return (
    <svg
      viewBox={`${minX} 10 ${width} 80`}
      width={Math.round(size * (width / 80))}
      height={size}
      style={style}
      role="img"
      aria-label="MittelBoost"
    >
      {!mono && (
        <defs>
          <linearGradient id={gradId} gradientUnits="userSpaceOnUse" x1="0" y1="88" x2="0" y2="12">
            <stop offset="0" stopColor={grad[0]} />
            <stop offset="1" stopColor={grad[1]} />
          </linearGradient>
        </defs>
      )}
      <polygon
        fill={fill}
        points="22,88 22,22 34,12 48,42 62,12 74,22 74,88 62,88 62,34 51,66 45,66 34,34 34,88"
      />
      {withLines && (
        <g stroke={fill} strokeWidth="5" strokeLinecap="butt">
          <line x1="3" y1="60" x2="17" y2="46" />
          <line x1="3" y1="73" x2="13" y2="63" />
          <line x1="3" y1="86" x2="9" y2="80" />
        </g>
      )}
    </svg>
  );
}

/* Wortmarke — fixe Vorgabe aus dem Brandbook:
   „Mittel" Sora SemiBold (600) + „Boost" Sora ExtraBold (800), Laufweite ca. −3 %. */
export function MittelBoostWordmark({ size = 17, color, boostColor = '#1DBE74', style }) {
  return (
    <span
      style={{
        fontFamily: 'var(--font)',
        fontSize: size,
        letterSpacing: '-0.03em',
        lineHeight: 1,
        whiteSpace: 'nowrap',
        userSelect: 'none',
        ...style,
      }}
    >
      <span style={{ fontWeight: 600, color: color || 'var(--text)' }}>Mittel</span>
      <span style={{ fontWeight: 800, color: boostColor }}>Boost</span>
    </span>
  );
}

/* Lockup horizontal: Marke + Wortmarke */
export function MittelBoostLockup({ size = 26, variant = 'dark', textColor, boostColor, style }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: Math.round(size * 0.38), ...style }}>
      <MittelBoostMark size={size} variant={variant} />
      <MittelBoostWordmark
        size={Math.round(size * 0.72)}
        color={textColor}
        boostColor={boostColor || (variant === 'light' ? '#0E3D2E' : '#1DBE74')}
      />
    </span>
  );
}
